module.exports = __webpack_public_path__ + "img/IMG_9997.0fac6b96.jpg";